import AppNumber from '@theme/components/atom/AppNumber'

export default {
  components: { AppNumber },
  props: {
    quantity: Number,
    displayedVariant: {
      type: Object,
      required: true,
    },
    sizes: {
      type: Object,
      default: () => ({ width: 0, height: 0 }),
    },
    extendedLabel: {
      type: Boolean,
      default: true,
    },
    mode: {
      type: String,
      default: 'base',
      validator: v => ['base', 'shortened'].includes(v),
    },
    targetId: String,
    disabledExternal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      pending: false,
      disabledLocal: false,
      disabledReason: null,
    }
  },

  computed: {
    isDisabled() {
      return this.disabledExternal || this.pending || this.disabledLocal
    },
    ariaDisabled() {
      return this.isDisabled ? 'true' : 'false'
    },
    label() {
      const sizeText = this.extendedLabel ? [this.sizes?.width, this.sizes?.height].join('×') + ' cm' : ''
      return this.$t('PageProductDetail.order', { size: sizeText })
    },
  },
  mounted() {
    this.$nuxt.$on('productConfigValidity', this.onConfigValidity)
  },
  beforeDestroy() {
    this.$nuxt.$off('productConfigValidity', this.onConfigValidity)
  },
  methods: {
    onConfigValidity({ isValid, pending, reason }) {
      this.pending = !!pending
      this.disabledLocal = !isValid
      this.disabledReason = reason || null
    },
    addToCart(event) {
      if (this.isDisabled) {
        event?.preventDefault?.()
        event?.stopPropagation?.()
        return
      }
      this.$emit('addToCart')
    },
  },
}
